<template>
  <div
    class="map"
  >
    <slot v-if="map" />
  </div>
</template>

<script>
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
import googleMapsLoader from '../../js/modules/google-maps-loader';

export const EVENTS = [
  'bounds_changed',
  'center_changed',
  'click',
  'dblclick',
  'drag',
  'dragend',
  'dragstart',
  'heading_changed',
  'idle',
  'maptypeid_changed',
  'mousemove',
  'mouseout',
  'mouseover',
  'projection_changed',
  'resize',
  'rightclick',
  'tilesloaded',
  'tilt_changed',
  'zoom_changed',
];

export default {
  name: 'GoogleMap',

  provide() {
    return {
      getInstance: this.getInstance,
    };
  },

  props: {
    options: {
      type: Object,
      required: true,
    },

    events: {
      required: false,
      type: Array,
      default: () => ['click'],
      validator(events) {
        return events.every((event) => EVENTS.includes(event));
      },
    },
  },

  data: () => ({
    map: null,
    google: null,
  }),

  watch: {
    options() {
      this.updateMap();
    },
  },

  async mounted() {
    this.google = await googleMapsLoader.load();
    this.map = new this.google.maps.Map(this.$el, this.options);

    this.events.forEach((eventName) => {
      this.map.addListener(eventName, () => {
        this.$emit(`map${upperFirst(camelCase(eventName))}`, {
          map: this.map,
          google: this.google,
        });
      });
    });

    // Raise a custom event when the map is drawn
    this.$emit('init', { map: this.map, google: this.google });
  },
  methods: {
    updateMap() {
      this.map.setOptions(this.options);
    },

    getInstance() {
      return {
        google: this.google,
        map: this.map,
      };
    },
  },
};
</script>
